import { useState } from "react"

import { useForm } from "@tanstack/react-form"

import { Button } from "@/components/ui/Button"
import { Input } from "@/components/ui/Input"

interface PracticeTypeStepProps {
  value: string
  onChange: (value: string) => void
  onValidation?: (isValid: boolean) => void
}

const PRACTICE_TYPE_OPTIONS = [
  { value: "Many Questions", label: "Many Questions" },
  { value: "Lots of discussion", label: "Lots of discussion" },
  { value: "Heads down reading time", label: "Heads down reading time" },
  { value: "I do, we do, you do", label: "I do, we do, you do" },
  { value: "Other", label: "Other" },
]

export function PracticeTypeStep({
  value,
  onChange,
  onValidation,
}: PracticeTypeStepProps) {
  const [showOtherInput, setShowOtherInput] = useState(false)
  const [otherValue, setOtherValue] = useState("")

  const form = useForm({
    defaultValues: {
      practiceType: value,
    },
  })

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  function handleOptionClick(optionValue: string, field: any) {
    if (optionValue === "Other") {
      setShowOtherInput(true)
      field.handleChange("")
      onChange("")
      onValidation?.(false)
    } else {
      setShowOtherInput(false)
      setOtherValue("")
      field.handleChange(optionValue)
      onChange(optionValue)
      onValidation?.(true)
    }
  }

  return (
    <div className="tw-text-center tw-space-y-8">
      <h2 className="tw-text-3xl tw-font-bold tw-text-gray-800 tw-inline-block">
        Is there any specific type of practice
        <br />
        you want this assignment to have?
      </h2>

      <form.Field name="practiceType">
        {(field) => {
          return (
            <div className="tw-max-w-2xl tw-mx-auto tw-space-y-2">
              <div className="tw-grid tw-grid-cols-2 tw-gap-4 tw-auto-rows-fr">
                {PRACTICE_TYPE_OPTIONS.map((option, index) => (
                  <Button
                    key={option.value}
                    type="button"
                    variant="selectable"
                    size="card"
                    selected={
                      (option.value === "Other" && showOtherInput) ||
                      field.state.value === option.value
                    }
                    onClick={() => handleOptionClick(option.value, field)}
                    className={
                      index === PRACTICE_TYPE_OPTIONS.length - 1 &&
                      PRACTICE_TYPE_OPTIONS.length % 2 !== 0
                        ? "tw-col-span-2 tw-max-w-md tw-mx-auto tw-w-full"
                        : ""
                    }
                  >
                    {option.label}
                  </Button>
                ))}
              </div>

              {showOtherInput && (
                <div className="tw-max-w-md tw-mx-auto tw-mt-6">
                  <Input
                    type="text"
                    placeholder="Enter practice type..."
                    value={otherValue}
                    onChange={(e) => {
                      const value = e.target.value
                      setOtherValue(value)
                      field.handleChange(value)
                      onChange(value)
                      onValidation?.(value.trim() !== "")
                    }}
                    className="tw-w-full tw-px-4 tw-py-3 tw-rounded-lg tw-border-2 tw-border-gray-300 focus:tw-border-emerald-600 focus:tw-outline-none tw-text-center"
                    autoFocus
                  />
                </div>
              )}
            </div>
          )
        }}
      </form.Field>
    </div>
  )
}
